
export const DELETE_STUDENT="student/delete_student";
export const SET_STUDENTS= "student/set_students";
export const ADD_STUDENT="student/add_student";
export const UPDATE_STUDENT="student/update_student";

export const DELETE_SUBJECT="subject/delete_subject";
export const SET_SUBJECTS= "subject/set_subjects";
export const ADD_SUBJECT="subject/add_subject";
export const UPDATE_SUBJECT="subject/update_subject";

export const DELETE_SUBJECT_INSTANCE="subject_instances/delete_subject_instance";
export const SET_SUBJECT_INSTANCES= "subject_instances/set_subject_instances";
export const ADD_SUBJECT_INSTANCE="subject_instances/add_subject_instance";
export const UPDATE_SUBJECT_INSTANCE="subject_instances/update_subject_instance";
export const GET_ATTENDANCE_CODE="subject_instances/get_attendance_code";

export const DELETE_ENROLLMENT="enrollment/delete_enrollment";
export const SET_ENROLLMENTS= "enrollment/set_enrollments";
export const ADD_ENROLLMENT="enrollment/add_enrollment";
export const UPDATE_ENROLLMENT="enrollment/update_enrollment";

export const DELETE_ASSIGNMENT="assignment/delete_assignment";
export const SET_ASSIGNMENTS= "assignment/set_assignments";
export const ADD_ASSIGNMENT="assignment/add_assignment";
export const UPDATE_ASSIGNMENT="assignment/update_assignment";

export const DELETE_GRADE="grade/delete_grade";
export const SET_GRADES= "grade/set_grades";
export const ADD_GRADE="grade/add_grade";
export const UPDATE_GRADE="grade/update_grade";

export const DELETE_ATTENDANCE="attendance/delete_attendance";
export const SET_ATTENDANCES= "attendance/set_attendances";
export const ADD_ATTENDANCE="attendance/add_attendance";
export const UPDATE_ATTENDANCE="attendance/update_attendance";
export const MARK_ATTENDANCE="attendance/mark_attendance";

export const DELETE_PAYMENT_RECORD="payment/delete_payment_record";
export const SET_PAYMENT_RECORDS= "payment/set_payment_records";
export const ADD_PAYMENT_RECORD="payment/add_payment_record";
export const UPDATE_PAYMENT_RECORD="payment/update_payment_record";
export const SET_TUITION_VALUES="tuition_values/set_tuition_values";
export const ADD_TUITION_VALUES="tuition_values/add_tuition_values";
export const UPDATE_TUITION_VALUES="tuition_values/update_tuition_values";


export const SET_SELECTED_STUDENT= "selected_student/set_selected_students";
export const UNSET_SELECTED_STUDENT= "selected_student/unset_selected_student";
export const SET_SELECTED_SUBJECT_INSTANCE= "selected_subject_instance/set_selected_subject_instance";
export const UNSET_SELECTED_SUBJECT_INSTANCE= "selected_subject_instance/unset_selected_subject_instance";

export const SET_DONE_LOADING = 'loading/set_done_loading';
export const SET_ATTENDANCE_MODIFIED ='loading/set_attendance_modified';
